import { AccessTokenStorage } from '@mam/main/Api/AccessTokenStorage';
import { Failure, Handler as ClientHandler, Request } from '@mam/main/ApiClient';

enum SuccessfulStatus {
	Ok = 200,
	Created = 201,
}

interface ErrorResponse {
	readonly errors: Array<{ code: string | null; title: string | null }>;
}

export class Handler implements ClientHandler {
	public constructor(private readonly accessTokenStorage: AccessTokenStorage) {}

	public async decode<R extends Request<Response>, Response>(
		response: globalThis.Response,
		request: R
	): Promise<Response> {
		const isJson = response.headers.get('Content-Type')?.startsWith('application/json') ?? false;
		const data = isJson ? await response.json() : {};
		const defined = SuccessfulStatus[response.status] !== undefined; // tslint:disable-line: strict-type-predicates
		if (defined) {
			return request.decode !== undefined ? request.decode(data) : (data as Response);
		}

		const errorCodes = (data as ErrorResponse).errors.map((error) => error.code ?? error.title ?? '<unknown>');
		throw new Failure<string>(new Set(errorCodes));
	}

	public prepare<R extends Request<Response>, Response>(urlRequest: RequestInit, request: R): RequestInit {
		if (!(request.isAuthenticated ?? true)) {
			return urlRequest;
		}

		const accessToken = this.accessTokenStorage.load();
		if (accessToken === null) {
			throw new Failure<string>(new Set(['missing-access-token']));
		}

		return {
			...urlRequest,
			headers: {
				...(urlRequest.headers ?? {}),
				Authorization: `Bearer ${accessToken}`,
			},
		};
	}
}
